/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Alternatives_Ranked_NoteInputs */

const en_directory_alternatives_ranked_note = /** @type {(inputs: Directory_Alternatives_Ranked_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editorial picks first; additional tools from the same category follow.`)
};

const zh_directory_alternatives_ranked_note = /** @type {(inputs: Directory_Alternatives_Ranked_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑策展优先，其余按同类目相关性排列。`)
};

/**
* | output |
* | --- |
* | "Editorial picks first; additional tools from the same category follow." |
*
* @param {Directory_Alternatives_Ranked_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_alternatives_ranked_note = /** @type {((inputs?: Directory_Alternatives_Ranked_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Alternatives_Ranked_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_alternatives_ranked_note(inputs)
	return zh_directory_alternatives_ranked_note(inputs)
});
export { directory_alternatives_ranked_note as "directory.alternatives.ranked_note" }